import FormComponent from '../../../../components/FormComponent';

const BUTTON_ICON = 'open-in-new';
const BUTTON_TARGET = '_blank';

/**
 * Single risk-assessment form question: intro, CTA, alert list, and info callout.
 * Content is driven by steps.js. Submits fieldName/value from steps on save.
 */
class InsuranceRiskAssessment extends FormComponent {
	constructor(containerElement, config) {
		super(containerElement, config);
		this.publishAnswerValue();
	}

	publishAnswerValue() {
		const fieldName = this.data?.fieldName || 'riskAssessment';
		const value = this.data?.value || 'completed';

		// Defer so FormGenerator can attach onChange before the answer is published
		queueMicrotask(() => {
			this.value = {
				fieldName,
				value
			};
		});
	}

	markup(_value, data = {}, titleMarkup = '') {
		const {
			instructionText = '',
			buttonLabel = '',
			buttonUrl = '',
			alertItems = [],
			facilitiesText = '',
			highlightText = ''
		} = data;

		const buttonMarkup =
			buttonLabel && buttonUrl
				? `<a
					href="${buttonUrl}"
					target="${BUTTON_TARGET}"
					rel="noopener noreferrer"
					class="lta-btn lta-btn--xs lta-btn--line lta-btn--icon lta-btn--icon-before p-venue-registration-insurance-info__risk-assessment-btn u-mb-3"
				>
					<svg class="lta-icon u-mr-1" width="1em" height="1em" fill="currentColor" aria-hidden="true">
						<use xlink:href="/static/images/icons/lta-icons.svg#${BUTTON_ICON}"></use>
					</svg>
					${buttonLabel}
				</a>`
				: '';

		const alertMarkup =
			alertItems?.length > 0
				? `<div class="lta-snackbar lta-snackbar--alert lta-snackbar--full u-mb-3" role="alert">
					<ul>
						${alertItems.map((item) => `<li><span>${item}</span></li>`).join('')}
					</ul>
				</div>`
				: '';

		const facilitiesMarkup = facilitiesText
			? `<div class="u-body1 u-text-grey-dark u-mb-3">${facilitiesText}</div>`
			: '';

		const highlightMarkup = highlightText
			? `<div class="lta-snackbar lta-snackbar--highlight lta-snackbar--full u-mb-3" role="status">
					<p class="u-body2 u-mb-0 u-text-grey-lta">${highlightText}</p>
				</div>`
			: '';

		return `
			<div class="p-venue-registration-insurance-info__risk-assessment">
				${titleMarkup}
				${instructionText ? `<div class="u-body1 u-text-grey-dark u-mb-3">${instructionText}</div>` : ''}
				${buttonMarkup}
				${alertMarkup}
				${facilitiesMarkup}
				${highlightMarkup}
			</div>
		`;
	}

	validate() {
		return true;
	}
}

export default InsuranceRiskAssessment;
